import { Episode, EpisodeCompoundId, Podcast } from '../models/podcasts';

export function trackAddToListenLaterClick(episode: Episode) {
  window.plausible('AddToListenLaterClick', { props: { episode_id: episode.id } });
}

export function trackPlayNextClick(episodeId: EpisodeCompoundId) {
  window.plausible('PlayNextClick', { props: { episode_id: episodeId } });
}

export function trackDownloadClick(episode: Episode) {
  window.plausible('DownloadClick', { props: { episode_id: episode.id } });
}

export function trackPlayNewEpisodeClick(episode: Episode) {
  window.plausible('PlayNewEpisodeClick', { props: { episode_id: episode.id } });
}

export function trackPlayEpisodeInUpNextClick(episode: Episode) {
  window.plausible('PlayEpisodeInUpNextClick', { props: { episode_id: episode.id } });
}

export function trackPlayEpisodeInUpNextAutomatically(episode: Episode) {
  window.plausible('PlayEpisodeInUpNextAutomatically', {
    props: { episode_id: episode.id },
  });
}

export function trackContinueListeningClick(episode: Episode) {
  window.plausible('ContinueListeningClick', { props: { episode_id: episode.id } });
}

export function trackLatestPodcastsClick(
  podcast: Podcast,
  index: number,
  unviewedEpisodeCount: number
) {
  window.plausible('LatestPodcastsClick', {
    props: { podcast: podcast.id, index, unviewed_episodes: unviewedEpisodeCount },
  });
}

export function trackLibraryPodcastClick(podcast: Podcast) {
  window.plausible('LibraryPodcastClick', { props: { podcast: podcast.id } });
}

export function trackBottomNavClick(route: string) {
  window.plausible('BottomNavClick', { props: { route } });
}

export function trackSkipAdInPlausible({
  subscriptionStore,
  subscriptionStatus,
  duration,
  credits,
}: {
  subscriptionStore: string;
  subscriptionStatus: string;
  duration: number;
  credits: number;
}) {
  window.plausible('SkipAd', {
    props: {
      subscription_store: subscriptionStore || 'no_store',
      subscription_status: subscriptionStatus || 'no_subscription',
      duration: Math.round(duration),
      credits,
    },
  });
}
